import Loading from './Loading'
import Vue from 'vue'


// 返回组件的构造函数
const LoadConstructor = Vue.extend(Loading)



// 构造实例
const instance = new LoadConstructor({ el: document.createElement('div') })


// 插件的方法对象
const loading = {
    show(message = '') {
        instance.isShow = true
        instance.message = message
        document.body.appendChild(instance.$el)
    },
    hide() {
        instance.isShow = false
        document.body.removeChild(instance.$el)
    }
}



// 插件统一格式
export default {
    install() {
        Vue.prototype.$loading = loading
    }
}